import request from '@/utils/request'

/**
 * 搜索项目
 * @method search
 * @param {Object} filters 筛选条件
 * @param {Object} options 搜索选项
 * @return {Promise} 异步返回项目信息
 */
export function searchProject(filters, options) {
  return request({
    url: '/api/search/project',
    method: 'post',
    data: {filters,options}
  })
}
